import { COLUMN_HOST_IP, COLUMN_NAME, COLUMN_TAG_MASK, COLUMN_TIME_ZONE } from "../../constants/column-types";
import { FILTER_TIME_ZONE } from "../../constants/filter-types";
import { TableColumn } from "../table/TableColumn";

const SiteColumns: TableColumn[] = [
    {
        heading: "Name",
        accessor: "name",
        isNumeric: false,
        id: 0,
        sortByName: "siteName",
        sortDirection: "asc",
        active: true,
        translationKey: "name",
        isDefault: true,
        columnId: COLUMN_NAME,
    },
    {
        heading: "Host IP",
        accessor: "hostIP",
        isNumeric: false,
        id: 1,
        sortByName: "siteHostip",
        sortDirection: "asc",
        active: true,
        translationKey: "hostIP",
        columnId: COLUMN_HOST_IP,
    },
    {
        heading: "Time Zone",
        accessor: "timeZone",
        isNumeric: false,
        id: 2,
        sortByName: "timeZone.zone",
        sortDirection: "asc",
        active: true,
        // searchOnName: "timeZone.id",
        // lookupName: "timeZone.zone",
        translationKey: "timeZone",
        columnId: COLUMN_TIME_ZONE,
        settingDataName: "timeZone",
        filterId: FILTER_TIME_ZONE
    },
    {
        heading: "Tag Mask",
        accessor: "tagmask",
        isNumeric: false,
        id: 3,
        sortByName: "siteTagmask",
        sortDirection: "asc",
        active: true,
        translationKey: "tagmask",
        columnId: COLUMN_TAG_MASK,
    },
];

export default SiteColumns
